import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CookieService } from 'ngx-cookie-service';
import { CookieSettingsModalComponent } from '../cookie-settings-modal/cookie-settings-modal.component';
import { AnalyticsCookieList, Cookie_Setting_Key, displayCookieConsentPopupPages, MarketingCookieList, UnclassifiedCookieList } from 'src/app/global-data/commonData';
import { commonFunctions } from 'src/app/global-data/commonFunction';
import { NavigationEnd, Router } from '@angular/router';


@Component({
  selector: 'app-cookie-accept-modal',
  templateUrl: './cookie-accept-modal.component.html',
  styleUrls: ['./cookie-accept-modal.component.scss']
})
export class CookieAcceptModalComponent implements OnInit {



   origin = window.location.origin

   cookieModal = {
     analytics:true,
     marketing:true,
     unclassified: true
   }

   cookiesAccepted = false;

  constructor(
    private cookieService : CookieService,
    private dialog: MatDialog,
    private commonFunctions: commonFunctions,
    private router: Router
  ) { }

  ngOnInit(): void {
    
    if(this.cookieService.get(Cookie_Setting_Key)){
       window['blockedCookies'] = [];
      this.cookiesAccepted = true;
      let cookies = JSON.parse(this.cookieService.get(Cookie_Setting_Key));

      // this.cookieModal = JSON.parse(this.cookieService.get(Cookie_Setting_Key));

      if(!cookies.analytics){
        window['blockedCookies'] = [...window['blockedCookies'],...AnalyticsCookieList];
      }
      if(!cookies.marketing){
        window['blockedCookies'] = [...window['blockedCookies'],...MarketingCookieList];
      }
       if(!cookies.unclassified){
        window['blockedCookies'] = [...window['blockedCookies'],...UnclassifiedCookieList];
      }
     
    }else {
      window['blockedCookies'] = [];
      this.checkForCookiePolicyModalUrls();
      
    }

    this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.checkForCookiePolicyModalUrls() 
        }
    })
  }

  checkForCookiePolicyModalUrls(){
    if(this.cookieService.get(Cookie_Setting_Key)){
      this.cookiesAccepted  = true;
      return;
    }
     if(displayCookieConsentPopupPages.find(item => item == window.location.pathname)){
        this.cookiesAccepted = false;
      }else {
        this.cookiesAccepted  = true;
      }
  }

  acceptAllCookie(){
    this.cookieModal.analytics = true;
    this.cookieModal.marketing = true;
    this.cookieModal.unclassified = true;
   
    this.commonFunctions.setCookie(Cookie_Setting_Key,JSON.stringify(this.cookieModal),365)
    this.cookiesAccepted = true;
     window['blockedCookies'] = [];
  }

  openCookieSettingModal() {

    const dialogRef =  this.dialog.open(CookieSettingsModalComponent,{
      width:'95%',
      maxWidth:'628px',
      maxHeight:'95vh'
    })

    dialogRef.afterClosed().subscribe((resp) => {
      if(resp){
        this.cookiesAccepted = true;
      }
    })
  }

}
